import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { SelectItem } from '../../../../shared';
import * as InvoiceActions from './invoice.actions';
import { Invoice } from './invoice.model';

export const invoicesFeatureKey = 'invoices';

export interface State extends EntityState<Invoice> {
    // additional entities state properties
    ActiveContracts: SelectItem[];
}

export const adapter: EntityAdapter<Invoice> = createEntityAdapter<Invoice>();

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
    ActiveContracts: []
});

const invoiceReducer = createReducer(
    initialState,
    on(InvoiceActions.addInvoice, (state, action) =>
        adapter.addOne(action.invoice, state)
    ),
    on(InvoiceActions.upsertInvoice, (state, action) =>
        adapter.upsertOne(action.invoice, state)
    ),
    on(InvoiceActions.addInvoices, (state, action) =>
        adapter.addMany(action.invoices, state)
    ),
    on(InvoiceActions.upsertInvoices, (state, action) =>
        adapter.upsertMany(action.invoices, state)
    ),
    on(InvoiceActions.updateInvoice, (state, action) =>
        adapter.updateOne(action.invoice, state)
    ),
    on(InvoiceActions.updateInvoices, (state, action) =>
        adapter.updateMany(action.invoices, state)
    ),
    on(InvoiceActions.deleteInvoice, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(InvoiceActions.deleteInvoices, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(InvoiceActions.loadInvoices, (state, action) =>
        adapter.setAll(action.invoices, state)
    ),
    on(InvoiceActions.clearInvoices, state => adapter.removeAll(state)),
    on(InvoiceActions.loadActiveContracts, (state, action) => ({
        ...state,
        ActiveContracts: action.contracts
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return invoiceReducer(state, action);
}
